<script setup>
import { convertToLastDay } from '../../helpers.js';
import { onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import Popup from '../miscellaneous/Popup.vue';

const store = useStore();
const paymentMethods = ref(null);
const paymentMethodModalOpen = ref(false);
const showExpiredText = ref(false);
const showSoonToExpireText = ref(false);

const checkIfCreditCardIsExpired = async () => {
    if (sessionStorage.getItem('expiredPaymentMethod')) {
        paymentMethodModalOpen.value = false;

        return false;
    }

    try {
        if (!paymentMethods.value) {
            paymentMethods.value = store.getters['user/getPaymentMethods'];

            if (!paymentMethods.value) {
                paymentMethods.value = await store.dispatch('payment_methods/index', {
                    params: { 'sort[by]': 'created_at' }
                });
            }
        }

        const paymentList = paymentMethods.value?.data;

        if (!Array.isArray(paymentList)) return false;

        const today = new Date();
        const nextMonth = new Date(today.getFullYear(), today.getMonth() + 1, 1);

        const checkExpiration = (method) => {
            const expires = method?.meta?.expires;

            if (!expires) return false;

            const expirationDate = convertToLastDay(expires);
            const isExpired = expirationDate < today;
            const isExpiringSoon =
                (expirationDate.getMonth() === nextMonth.getMonth() && expirationDate.getFullYear() === nextMonth.getFullYear()) ||
                (expirationDate.getMonth() === today.getMonth() && expirationDate.getFullYear() === today.getFullYear());

            return { isExpired, isExpiringSoon, method };
        };

        const result = paymentList.reduce((found, method) => {
            if (found) return found;

            const status = checkExpiration(method);

            if (!status) return null;

            if (status.isExpired) return { ...status, type: 'expired' };

            if (status.isExpiringSoon) return { ...status, type: 'expiringSoon' };

            return null;
        }, null);

        if (!result) return false;

        paymentMethodModalOpen.value = true;
        paymentMethods.value = result.method;

        if (result.type === 'expired') {
            sessionStorage.setItem('expiredPaymentMethod', true);
            showExpiredText.value = true;
        } else {
            sessionStorage.setItem('expiredPaymentMethod', true);
            showSoonToExpireText.value = true;
        }

        return true;
    } catch (error) {
        console.error('Kreditkartenprüfung fehlgeschlagen:', error);

        return false;
    }
};

onMounted(async () => {
    await checkIfCreditCardIsExpired();
});
</script>

<template>
    <teleport to="body">
        <Popup :overflow-hidden="false" :open="paymentMethodModalOpen" class="px-6" @open="paymentMethodModalOpen = $event">
            <div class="p-6 text-center">
                <h2>{{ $t('action_required') }}</h2>
                <p v-if="showExpiredText" class="mb-4" v-html="$t('expired_card_notice_with_last_digits', { lastDigits: paymentMethods.meta?.display_text?.split(' ').at(-1) })" />
                <p
                    v-if="showSoonToExpireText"
                    class="mb-4"
                    v-html="$t('soon_to_expire_card_notice_with_last_digits', { lastDigits: paymentMethods.meta?.display_text?.split(' ').at(-1) })"
                />
                <button class="btn primary mt-4 mb-2" @click="$router.push('/profile/paymentmethods')">{{ $t('go_to_payment_methods') }}</button>
            </div>
        </Popup>
    </teleport>
</template>
